export function hasMethod(obj, name) {
  return typeof obj[name] === 'function';
}
export function getComponentElements(nameOrSelector) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var selector = "[data-component=\"".concat(nameOrSelector, "\"]");
  var elements = [];

  try {
    elements = Array.from(element.querySelectorAll(selector));
  } catch (_unused) {}

  if (elements.length === 0) {
    elements = Array.from(element.querySelectorAll(nameOrSelector));
  }

  return elements;
}